import { z } from "zod";

export const addVehicleCategoryFormSchema = z
  .object({
    name: z.string().min(1, "Field is required and can't be empty.").max(32, "Maximum of 32 characters."),
    class: z.string().min(1, "Field is required and can't be empty."),
    type: z.string().min(1, "Field is required and can't be empty."),
    capacity: z
      .number({
        message: "Field is required and can't be empty.",
      })
      .min(0)
      .max(999)
      .step(1, "Field must be a whole number."),
    bags: z
      .number({
        message: "Field is required and can't be empty.",
      })
      .min(0)
      .max(999)
      .step(1, "Field must be a whole number."),
    waitTimeCost: z
      .number({
        message: "Field is required and can't be empty.",
      })
      .min(0)
      .max(999)
      .step(0.01, "Field must be a maximum of 2 decimal places."),
    costAdjustment: z
      .number({
        message: "Field is required and can't be empty.",
      })
      .min(-99)
      .max(999)
      .step(0.01, "Field must be a maximum of 2 decimal places."),
    associatedVehicles: z.array(z.string()),

    //advanced settings
    enableCustomCommission: z.boolean(),
    commissionRate: z.number().optional(),

    // offload settings (hidden from UI, kept for type compatibility with DispatchSettings components)
    enableCustomOffload: z.boolean(),
    offloadDispatchTolerance: z.string().optional(),
    offloadEngineTypes: z.array(z.string()).optional(),
    offloadMaxVehicleAge: z.number().optional(),
    offloadMinimumRating: z.number().optional(),
    offloadVehicleColors: z.array(z.string()).optional(),
    offloadEnableSpecificModels: z.boolean(),
    offloadVehicleModels: z.array(z.string()).optional(),
  })
  .refine(
    (data) => {
      if (data.enableCustomCommission) {
        return data.commissionRate !== undefined && data.commissionRate >= -90 && data.commissionRate <= 90;
      }
      return true;
    },
    {
      message: "Field must be a whole number.",
      path: ["commissionRate"],
    }
  );
export type AddVehicleCategoryFormData = z.infer<typeof addVehicleCategoryFormSchema>;
